import type { UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "app/modules/api-client";
import type {
    IUrlSidePanelData,
    IUrlSidePanelParams,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/types";
import type {
    IAnalyzedURL,
    IURLFilterState,
    IURLsResponse,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/url-table/types";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export interface IURLsRequestParams extends ILLMWidgetRequestParams, IURLFilterState {
    pageSize: number;
    page: number;
    sort: keyof IAnalyzedURL;
    asc: boolean;
    includeFacets?: boolean;
}

export const useAnalyzedUrls = (
    params: IURLsRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<IURLsResponse> =>
    useLLMReportQuery<IURLsResponse, IURLsRequestParams>(
        "urlsData",
        apiClient.AiTracker.aiTrackerReportsSourceAnalysisReportUrlAnalysisTableList,
        params,
        options,
    );

export const useUrlSidePanel = (
    params: IUrlSidePanelParams,
    options?: { enabled?: boolean },
): UseQueryResult<IUrlSidePanelData> =>
    useLLMReportQuery<IUrlSidePanelData, IUrlSidePanelParams>(
        "urlSidePanel",
        apiClient.AiTracker.aiTrackerReportsSourceAnalysisReportSidePanelList,
        params,
        options,
    );
